'use client';
import './locations-map-styles.css';

export const LocationsMap = (props: any) => {
  return (
    <div style={{ width: '100%', height: '100%' }} className="map-frame">
      <iframe
        src="https://www.google.com/maps/d/u/0/embed?mid=1zJcTbsgggdadgwzUGDmjsTd6nwtNaNY&ehbc=2E312F&noprof=1"
        className="h-[500px] w-full"
      />
    </div>
  );
};
